import React, {useState} from 'react';
import s from './RoutConstructor.module.css'
import gameService from "../../../../Service/EntityService";
const RoutConstructorComponent = ({games, setGames, levels, setIsLoad, setErrorMessage, gameEntityName}) => {
    const [selectGame, setSelectGame] = useState(games && games.length?games[0]:null)
    console.log('games', levels, games, selectGame)

    const saveGame = async ()=>{
        setIsLoad(false)
        try {
            const game = await  gameService.update(gameEntityName, selectGame)
            setGames(games.map(g => {
                if(g.id === selectGame.id){
                    return game
                }
                return g
            }))
        } catch (e) {
            console.log(e)
            setErrorMessage(e)
        } finally{
            setIsLoad(true)
        }
    }

    if (!selectGame ){
        return <div>Нет доступных игр</div>
    }
    return (
        <div className={s.wrapper}>
            {
                <select value={selectGame.id} onChange={(e)=>{setSelectGame(games.find(g=>g.id === e.target.value))}}>
                    {
                        games.map(game=>{
                            return <option key={"select_"+game.id} value={game.id}>{game.title??""}</option>
                        })
                    }
                </select>
            }
            {selectGame.teamRoutes?
                <div>
                    {
                        selectGame.teamRoutes.map((routTeam,i)=>{
                            return <div className={s.teamCard} key={"rout_"+i}>
                                <div>
                                   {routTeam.team?.id??""}
                                </div>
                                <div>
                                    <input type="text" onChange={(e)=>{
                                        routTeam.team.name = e.target.value
                                        setSelectGame({...selectGame})
                                    }} value={routTeam.team?.name??""} placeholder={"наименование команды"} />
                                </div>
                                <div>Маршрут:</div>
                                { selectGame.levels?.length>0?routTeam.rout?.map((routTeamId, routIndex)=>{
                                    return (
                                       <div key={`${selectGame.id}${i}${routIndex}${routTeamId}`}>
                                           <span>{routIndex+1}) </span>
                                           <select value={routTeamId} onChange={(e)=>{
                                               routTeam.rout[routIndex] = e.target.value
                                               setSelectGame({...selectGame})
                                           }}>
                                               {selectGame.levels?.length?
                                                   levels.map(level=>{
                                                       return <option key={level} value={level.id}>{level.title}</option>
                                                   })
                                                   :<></>
                                               }
                                               <option value=""></option>
                                           </select>
                                       </div>
                                        // <div key={`${selectGame.id}${i}${routTeamId}`}>{routIndex+1}) {level?level.title:"-"}</div>
                                    )
                                }):<div>Не задано точек маршрута для игры</div>
                                }
                                <div className={s.localBtn} onClick={()=>{
                                    if (!routTeam.rout) {
                                        routTeam.rout = []
                                    }
                                    routTeam.rout.push("")
                                    setSelectGame({...selectGame})
                                }}>Добавить точку маршрута</div>
                                {
                                    routTeam.rout?.length>0?<div className={s.localBtn} onClick={()=>{
                                        routTeam.rout =  routTeam.rout.slice(0,-1)
                                        setSelectGame({...selectGame})
                                    }}>Убрать точку маршрута</div>:<></>
                                }
                            </div>
                        })
                    }
                </div>
                : <div>Нет маршрутов</div>
            }
            <div className={"btn"} onClick={()=>{
                if (!selectGame.teamRoutes) {
                    selectGame.teamRoutes = []
                }
                const newTeamId = `team${selectGame.teamRoutes.length+1}`
                selectGame.teamRoutes.push({team:{id:newTeamId, name:""}})
                setSelectGame({...selectGame})
            }}>Добавить маршрут</div>

            {
                selectGame.teamRoutes?.length?
                    <div className={"btn"} onClick={()=>{
                        selectGame.teamRoutes =  selectGame.teamRoutes.slice(0,-1)
                        setSelectGame({...selectGame})
                    }}>Убрать маршрут</div>
                    : <></>
            }
            <div className={"btn"} onClick={saveGame}>Сохранить</div>
            <div className={"btn"} onClick={()=>{
                setSelectGame(games.find(g=>g.id === selectGame.id))
            }}>Отмена</div>
        </div>
    );
};

export default RoutConstructorComponent;